import { toast } from "react-toastify";

const clickableOptions = (onClick) =>
  onClick
    ? {
        onClick,
        style: { cursor: "pointer" },
        closeOnClick: true,
      }
    : {};

export const notify = {
  success: (message, onClick) => {
    toast.success(message, clickableOptions(onClick));
  },

  error: (message, onClick) => {
    toast.error(message, clickableOptions(onClick));
  },

  info: (message, onClick, options = {}) => {
    toast.info(message, { ...clickableOptions(onClick), ...options });
  },

  warning: (message, onClick) => {
    toast.warning(message, clickableOptions(onClick));
  },

  loading: (message) =>
    toast.loading(message, {
      position: "top-right",
    }),

  update: (id, message, type = "success") =>
    toast.update(id, {
      render: message,
      type,
      isLoading: false,
      autoClose: type === "error" ? 5000 : 3000,
    }),

  // Closes a specific toast by id (no-op if it isn't showing) — used to
  // clear a stale "no results" toast once a later search finds data.
  dismiss: (id) => toast.dismiss(id),
};